<nav *ngIf="fatura && !fatura.isAutoNegotiationRedirectionEnabled && showTicket; else isShowTicket">
  <ae-buttons>
    <ae-buttons-button class="ae-buttons-white">
      <a href="javascript:return" (click)="accessFatura($event)">Visualizar Boleto</a>
    </ae-buttons-button>
    <ae-buttons-button>
      <a href="#" id="copyButton" (click)="copyBarCode($event)" [ngClass]="{'disabled': (!faturaDetalhada.linhaDigitavel)}" >Copiar Código</a>
    </ae-buttons-button>
  </ae-buttons>
</nav>

<ae-toast 
  message="Código de barras copiado" 
  *ngIf="copied"
  [timeElapsed]="3000"
  (onClose)="copied = false"
></ae-toast>

<ng-template #isShowTicket>
  <nav>
    <ae-buttons>
      <ae-buttons-button>
        <a href="#" (click)="clickShowTicket($event)">Boleto</a>
      </ae-buttons-button>
    </ae-buttons>
  </nav>
</ng-template>

<nav *ngIf="fatura && fatura.isAutoNegotiationRedirectionEnabled">
  <ae-buttons>
    <ae-buttons-button>
      <a href="/conheca-portal?faturaId={{fatura.bankSliptId}}">Simular negociação</a>
    </ae-buttons-button>
  </ae-buttons>
</nav>